module.exports = __webpack_public_path__ + "img/五期生一周年繪圖-SHISHIRO - 三世吾郎.671c63fe.png";